import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useFetchPublicRestaurantQuery, useFetchRestaurantsByOwnerMutation } from '@/api/hooks/useRestaurant';
import { SimpleRestaurantResponse } from '@/api/lib/restaurant';
import { useAuthContext } from '@/contexts/auth';

import { PageTitle } from '@/components/molecules/PageTitle';
import { ClaimRestaurantForm } from '@/components/organisms/ClaimRestaurantForm';
import { Typography } from '@/components/atoms/Typography';

export const ClaimPage = () => {
  const { user } = useAuthContext();

  const { id } = useParams();
  const restaurantId = id || '';

  const { data: restaurant } = useFetchPublicRestaurantQuery({ id: restaurantId, withMenu: false }, { enabled: !!restaurantId });

  const [_restaurantsData, setRestaurantsData] = useState<SimpleRestaurantResponse[]>([]);

  const { mutate: fetchRestaurantsByOwner } = useFetchRestaurantsByOwnerMutation({
    onSuccess: (data: SimpleRestaurantResponse[]) => {
      setRestaurantsData(data);
    }
  });

  useEffect(() => {
    if (user) {
      fetchRestaurantsByOwner({});
    }
  }, [fetchRestaurantsByOwner, user]);

  return (
    <div className="h-full min-h-screen w-full mx-auto bg-yellow-50">
      <div className="max-w-6xl mx-auto">
        <PageTitle firstTitle="Être propriétaire de" secondTitle={restaurant?.name} />
      </div>

      <div className="m-auto flex items-center text-center mt-10 justify-center flex-col bg-yellow-200 w-fit py-5 px-10 rounded-lg">
        <Typography>En remplissant les champs ci-dessous, vous prouvez que ce restaurant vous appartient.</Typography>
        <Typography>Notre équipe analysera votre demande et vous serez informé par email.</Typography>
      </div>

      <div className="flex flex-col md:flex-row gap-5 md:gap-20 mt-10 pb-20 justify-center">
        <section className="bg-white max-w-6xl md:border rounded-xl md:p-10 p-5">
          <ClaimRestaurantForm
            restaurant={
              restaurant
                ? {
                    ...restaurant,
                    tagIds: restaurant.tags.map((tag) => tag.id)
                  }
                : undefined
            }
            userEmail={user?.email}
            initialData={{
              autocompleteName: restaurant?.name || '',
              isPlaceAlreadyRegistered: false,
              placeId: restaurant?.gmapPlaceId || '',
              phoneNumber: restaurant?.phoneNumberOwner || '',
              firstName: restaurant?.firstNameOwner || '',
              lastName: restaurant?.lastNameOwner || '',
              company: restaurant?.digitalCertificate?.company || '',
              suppliers: restaurant?.digitalCertificate?.suppliers || []
            }}
          />
        </section>
      </div>
    </div>
  );
};
